module.exports = __webpack_public_path__ + "static/media/sanding@2x.a2000617.jpg";